<template>
  <div class="footer">
    <b-container class="footer-container">
      <b-row>
        <b-col>
          <b-link href="https://discord.gg/snkrhud" target="_blank" class="btn-join-now"></b-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5 class="title">About</h5>

          <router-link class="blnk" to="/about-us">
            <img
              src="@/assets/rebrand/footer/snkrhud-logo.png"
              alt="snkrhud"
              class="ftr-snkrhud-logo"
            />
          </router-link>
        </b-col>
        <b-col>
          <h5 class="title">Socials</h5>
          <div class="btn-group">
            <b-link class="blnk" href="https://www.instagram.com/snkrhud/?hl=en" target="_blank">
              <img
                src="@/assets/rebrand/footer/instagram.png"
                alt="instagram"
                class="ftr-social-logo"
              />
            </b-link>
            <b-link class="blnk" href="https://www.facebook.com/SNKRHUD/" target="_blank">
              <img
                src="@/assets/rebrand/footer/facebook.png"
                alt="facebook"
                class="ftr-social-logo"
              />
            </b-link>
            <b-link
              class="blnk"
              href="https://twitter.com/snkrhud?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              target="_blank"
            >
              <img
                src="@/assets/rebrand/footer/twitter.png"
                alt="twitter"
                class="ftr-social-logo"
              />
            </b-link>
            <b-link class="blnk" href="mailto:help@snkrhud.com" target="_blank">
              <img src="@/assets/rebrand/footer/gmail.png" alt="gmail" class="ftr-social-logo" />
            </b-link>
          </div>
        </b-col>
        <b-col sm="4">
          <h5 class="title">Partners</h5>
          <div class="partner-group">
            <b-link class="blnk" href="#">
              <img src="@/assets/rebrand/footer/flow.png" alt="flow" class="ftr-partners-logo" />
            </b-link>
            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/dapper.png"
                alt="dapper"
                class="ftr-partners-logo"
              />
            </b-link>
            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/snap-inc.png"
                alt="snap inc"
                class="ftr-partners-logo"
              />
            </b-link>

            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/orange-dao.png"
                alt="orange dao"
                class="ftr-partners-logo"
              />
            </b-link>
            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/gaingels.png"
                alt="gaingels"
                class="ftr-partners-logo"
              />
            </b-link>

            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/redbeard-ventures.png"
                alt="redbeard ventures"
                class="ftr-partners-logo"
              />
            </b-link>

            <!-- <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/nft-genius.png"
                alt="nft genius"
                class="ftr-partners-logo"
              />
            </b-link> -->
            <b-link class="blnk" href="#">
              <img
                src="@/assets/rebrand/footer/audacity-fund.png"
                alt="audacity fund"
                class="ftr-partners-logo"
              />
            </b-link>

            <b-link class="blnk" href="#">
              <img src="@/assets/rebrand/footer/gaia.png" alt="gaia" class="ftr-partners-logo" />
            </b-link>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link to="/terms-and-condition" class="terms">
            Terms and Condition
          </router-link>
        </b-col>
      </b-row>
    </b-container>
    <img src="@/assets/rebrand/footer/footer-overlay.png" alt="footer" class="footer-overlay -wb" />
    <img src="@/assets/mobile/footer-overlay.png" alt="footer" class="footer-overlay -mb" />
    <img src="@/assets/mobile/footer-grid.png" alt="footer" class="footer-grid -mb" />
  </div>
</template>
<script>
export default {
  name: 'footercontent',
};
</script>
<style lang="scss">
.footer {
  height: 43vw;
  background: #e2e2e2;
  overflow: hidden;
  position: relative;
  a.terms {
    color: #c844f2;

    font-family: "quasimoda", sans-serif;
    text-transform: uppercase;
    font-size: 1.2vw;
    position: relative;
    z-index: 10;
    border-bottom: 2px solid #c844f2;
    text-align: center;
    display: block;
    margin:2.5% auto 0 auto;
    width: max-content;
    text-decoration: none;
  }
  &::before {
    content: "";
    width: 100%;
    height: 1px;
    border-top: 1px solid #000;
    position: absolute;
    top: 0.5vw;
    right: 0;
    left: 0;
  }
  &::after {
    content: "";
    width: 37%;
    height: 1px;
    border-top: 1px solid #000;
    position: absolute;
    top: 2vw;
    right: 0;
    left: 0;
    margin: 0 auto;
  }
  .footer-container {
    max-width: 85%;
  }
  &.remove-btn {
    height: 33vw;
    .btn-join-now {
      display: none;
    }
    h5.title {
      margin-top: 10vw;
    }
    .footer-overlay {
      width: 125%;
      position: absolute;
      top: -26vw;
      left: -18.5vw;
      z-index: 0;
    }
  }
  .btn-join-now {
    background: url("../assets/rebrand/footer/join-now.png");
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
    width: 42vw;
    height: 8.5vw;
    border: 0 !important;
    margin: 9vw auto 0 auto;
    display: block;
    font-family: "kawaru", sans-serif;
    font-style: normal;
    font-weight: 100;
    font-size: 3.8vw;
    text-shadow: 4px 1px #02be02;
    padding-bottom: 1vw;
    letter-spacing: 4px;
    margin-bottom: 5vw;
    opacity: 0.8;
    position: relative;
    z-index: 3;
  }
  h5.title {
    font-size: 1.2vw;
    color: #000000;
    display: block;
    letter-spacing: 1px;
    text-transform: uppercase;
    line-height: 1.6;
    white-space: nowrap;
    position: relative;
    z-index: 2;
    text-align: center;
    font-family: "quasimoda", sans-serif;
    font-weight: 300;
    position: relative;
    z-index: 3;
  }
  .blnk {
    position: relative;
    z-index: 2;
    // margin: 0 0.5vw;
    display: block;
    .ftr-snkrhud-logo {
      width: 11vw;
      height: 5vw;
      object-fit: contain;
      margin: 2.3vw auto 0 auto;
      display: block;
    }
  }

  .btn-group {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    max-width: 80%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    .blnk {
      position: relative;
      z-index: 2;
      .ftr-social-logo {
        height: 3.3vw;
        width: 3.3vw;
        object-fit: contain;
        margin: 2.5vw auto 0 auto;
        display: block;
        image-rendering: optimizeQuality;
      }
    }
  }
  .partner-group {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 2.5vw auto 0 auto;
    position: relative;
    z-index: 1;
    & > * {
      cursor: default;
    }
    .blnk {
      position: relative;
      z-index: 2;
      .ftr-partners-logo {
        height: 3.4vw;
        width: 6vw;
        object-fit: contain;
        margin: 0 0 1vw 0;
        display: block;
        image-rendering: optimizeQuality;
      }
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        flex: 0 0 25%;
        .ftr-partners-logo {
          width: 80%;
        }
      }
      &:nth-child(4) {
        flex: 0 0 25%;
        justify-content: flex-end;
        margin-left: -1vw;
        .ftr-partners-logo {
          width: 75%;
        }
      }
      &:nth-child(5) {
        flex: 0 0 34%;
        display: flex;
        justify-content: center;
        margin-left: -3vw;
        .ftr-partners-logo {
          width: 100%;
        }
      }
      &:nth-child(6) {
        flex: 0 0 20%;
        display: flex;
        justify-content: center;
        .ftr-partners-logo {
          width: 100%;
          height: 4vw;
        }
      }
      &:nth-child(7) {
        flex: 0 0 32%;
        display: flex;
        justify-content: center;
        .ftr-partners-logo {
          width: 100%;
          height: 3vw;
        }
      }
      &:nth-child(8) {
        flex: 0 0 20%;
        display: flex;
        justify-content: center;
        margin-right: -2vw;
        .ftr-partners-logo {
          width: 95%;
          height: 3vw;
        }
      }
      &:nth-child(9) {
        flex: 0 0 22%;
        display: flex;
        justify-content: center;
        .ftr-partners-logo {
          height: 3.8vw;
          width: 6vw;
        }
      }
    }
  }
  .footer-overlay {
    width: 122%;
    position: absolute;
    top: -16vw;
    left: -16.5vw;
    z-index: 0;
  }
}
@media (max-width: 1024px) {
  .footer {
    height: 145vw;
    &::before,
    &::after {
      content: none !important;
    }
    .btn-join-now {
      width: 66vw;
      height: 12.5vw;
      margin: 23vw auto 2vw auto;
    }
    .col,
    .col-sm-4 {
      max-width: 100%;
      width: 100%;
      min-width: 100%;
      flex: 1 1 100%;
    }
    h5.title {
      font-size: 14px;
      margin-top: 9vw;
    }
    .footer-overlay {
      width: 119%;
      top: 3vw;
      left: -9vw;
      height: 134vw;
    }
    .footer-grid {
      width: 145%;
      top: -6vw;
      left: -24vw;
      height: 87vw;
      position: absolute;
    }
    .blnk {
      display: block;
      .ftr-snkrhud-logo {
        width: 21vw;
        height: 8vw;
      }
    }

    .partner-group {
      .blnk {
        display: block;
        .ftr-partners-logo {
          height: 10vw;
          margin: 0 1vw 1vw 1vw;
        }
        // &:nth-child(4) {
        //   flex: 0 0 37%;
        //   .ftr-partners-logo {
        //     height: 9.5vw;
        //     width: 27vw;
        //   }
        // }
        // &:nth-child(5) {
        //   flex: 0 0 15%;
        //   .ftr-partners-logo {
        //     height: 9.5vw;
        //     width: 13vw;
        //   }
        // }
        &:nth-child(6) {
          .ftr-partners-logo {
            height: 10vw;
          }
        }
        &:nth-child(7) {
          margin-top: 3vw;
          .ftr-partners-logo {
            height: 10vw;
          }
        }
        &:nth-child(8) {
          margin-top: 3vw;
          .ftr-partners-logo {
            height: 10vw;
          }
        }
        // &:nth-child(9) {
        //   margin-top: 3vw;
        //   .ftr-partners-logo {
        //     height: 8.8vw;
        //     width: 14vw;
        //   }
        // }
      }
    }
    .btn-group {
      max-width: 65%;
      .blnk {
        display: block;

        .ftr-social-logo {
          width: 22vw;
          height: 10vw;
        }
      }
    }
  }
}
@media (max-width: 769px) {
  .footer {
    height: 165vw;
    .footer-overlay {
      height: 154vw;
    }
    a.terms {
      color: #c844f2;
      font-family: "brevier", sans-serif;
      text-transform: uppercase;
      font-size: 14px;
      position: relative;
      z-index: 10;
      border-bottom: 2px solid #c844f2;
      text-align: center;
      display: block;
      margin: 19% auto 0 auto;
    }
  }
}
</style>
